import { TRACKING_PARAMS } from "@/types/sessionState";

/**
 * Capture URL parameters relevant for analytics tracking
 * Includes marketing params (gclid, utm_*, fbclid, etc.) and any custom params
 */
export function captureUrlParams(): Record<string, string> {
  const params = new URLSearchParams(window.location.search);
  const captured: Record<string, string> = {};

  // First, capture all known tracking parameters
  for (const param of TRACKING_PARAMS) {
    const value = params.get(param);
    if (value) {
      captured[param] = value;
    }
  }

  // Also capture any other parameters (step, sessionId, development, etc.)
  params.forEach((value, key) => {
    if (!captured[key] && value) {
      captured[key] = value;
    }
  });

  return captured;
}

/**
 * Get the full current URL including all parameters
 */
export function getFullUrl(): string {
  return window.location.href;
}

/**
 * Extract marketing source from URL params
 * Returns a normalized source name for analytics
 */
export function getMarketingSource(params: Record<string, string>): string {
  if (params.utm_source) {
    return params.utm_source;
  }
  if (params.gclid || params.gbraid || params.wbraid) {
    return "google_ads";
  }
  if (params.fbclid) {
    return "facebook";
  }
  if (params.msclkid) {
    return "microsoft_ads";
  }
  if (params.ttclid) {
    return "tiktok";
  }
  if (params.li_fat_id) {
    return "linkedin";
  }
  if (params.ref || params.referrer) {
    return params.ref || params.referrer;
  }
  return "direct";
}

/**
 * Check if URL has any marketing parameters
 */
export function hasMarketingParams(params: Record<string, string>): boolean {
  return TRACKING_PARAMS.some((param) => param in params);
}
